import {
  AlertTimeoutThreshold,
  AsterixConfiguration,
  CommonConfiguration,
  CommonSensorStatus,
  HasVersion,
  PortConfiguration,
  RemoteHostConfiguration,
  SensorTypeEnum,
  SpecificStateEnum,
} from './common.types';
import { Common3DRadarConfiguration } from './radar.types';

export interface XentaSensorConfiguration
  extends
    CommonConfiguration,
    PortConfiguration,
    RemoteHostConfiguration,
    AsterixConfiguration,
    Common3DRadarConfiguration,
    AlertTimeoutThreshold {
  type: SensorTypeEnum.XENTA;
}

export enum XentaTransmitStateEnum {
  UNKNOWN = 'UNKNOWN',
  SECURITY_SAFE = 'SECURITY_SAFE',
  NOT_READY = 'NOT_READY',
  STANDBY = 'STANDBY',
  REDUCED_POWER = 'REDUCED_POWER',
  FULL_POWER = 'FULL_POWER',
}

export enum XentaMastMotionEnum {
  UNKNOWN = 'UNKNOWN',
  NOT_MOVING = 'NOT_MOVING',
  MOVING = 'MOVING',
}

export enum XentaCapabilityStatusTypeEnum {
  UNKNOWN = 'UNKNOWN',
  TRANSMITTER_STATE = 'TRANSMITTER_STATE',
  // Voir XentaCapabilityStatusType.java si besoin des autres valeurs
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SPECIFIC_XENTA_CAPABILITY_STATUS = [
  XentaCapabilityStatusTypeEnum.TRANSMITTER_STATE,
] as const satisfies readonly XentaCapabilityStatusTypeEnum[];

export type SpecificXentaCapabilityStatus = (typeof SPECIFIC_XENTA_CAPABILITY_STATUS)[number];

export type GenericXentaCapabilityStatus = Exclude<XentaCapabilityStatusTypeEnum, SpecificXentaCapabilityStatus>;

export interface AbstractXentaCapabilityState<key extends XentaCapabilityStatusTypeEnum> {
  capabilityType: key;
}

export interface TransmitterState extends AbstractXentaCapabilityState<XentaCapabilityStatusTypeEnum.TRANSMITTER_STATE> {
  transmitState: XentaTransmitStateEnum;
}

export type XentaCapabilities = { [key in GenericXentaCapabilityStatus]?: AbstractXentaCapabilityState<key> } & {
  [XentaCapabilityStatusTypeEnum.TRANSMITTER_STATE]?: TransmitterState;
};

export enum TokenStatus {
  MASTER = 'MASTER',
  WAIT_FOR_ACQUISITION = 'WAIT_FOR_ACQUISITION',
  REFUSED = 'REFUSED',
  PASSIVE = 'PASSIVE',
}

export type XentaSpecificStateEnum =
  | SpecificStateEnum.EMITTING
  | SpecificStateEnum.ROTATING
  | SpecificStateEnum.STOP_AND_STARE;

export interface XentaSensorStatus extends CommonSensorStatus, HasVersion {
  type: SensorTypeEnum.XENTA;
  mastMotion: XentaMastMotionEnum;
  capabilities: XentaCapabilities;
  tokenStatus: TokenStatus;
  specificState: XentaSpecificStateEnum | null;
}
